/*                              */
/*                                 */
import { get_current_component } from "svelte/internal";

export function applyAttributesToHost(attributes: Record<string, unknown>): void {
  const { host } = get_current_component().$$.root as { host: HTMLElement };
  Object.entries(attributes).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      host.removeAttribute(key);
    } else {
      host.setAttribute(key, `${value}`);
    }
  });
}
